import { Dmenu } from "./class/dmenu.js"; //ドロワーメニュー
import { Env } from "./class/env.js"; //ブラウザなど環境チェック
//import { LazyLoad } from "./class/lazyload.js";
import { ScrChecker } from "./class/scroll-checker-simple.js";
import { Opening } from "./class/opening-mov-callback.js"; //オープニング関連
import { ResizeElem } from "./class/resize.js";
import { PageAncher } from "./class/page-ancher.js"; //ページ内アンカーリンク（スムーズスクロール）

import smoothscroll from "smoothscroll-polyfill";
// window.scroll smooth not working on Safari
// https://stackoverflow.com/questions/51731754/window-scroll-smooth-not-working-on-safari
// Window.scroll() https://developer.mozilla.org/en-US/docs/Web/API/Window/scroll

export class Main {
  constructor() {
    this.timerResized = false; //resize時
    this.timerScrolled = false; //scroll時
    this._click = "";
    this.env = {};
    this.loadedFlg = false;
    this.scrChecker = {};
    this.openingManager = {};
    this.resize = {};
    this.body = {};
    this.html = {};
    this.dmenu = {};
  }

  init() {
    window.addEventListener("DOMContentLoaded", () => {
      this.body = document.getElementsByTagName("body")[0];
      this.html = document.getElementsByTagName("html")[0];

      // ブラウザOS環境
      this.env = new Env();
      this.env.detectEnv();

      // dmenu
      this.dmenu = new Dmenu();
      this.dmenu.init();

      // スクロールチェッカー
      this.scrChecker = new ScrChecker();
      this.scrChecker.init();

      // Opening(終了時コールバックする)
      //this.openingManager = new Opening(this.init2);//ここで this.init2 を直接渡すと、メソッドは Main クラスのコンテキストを失う
      this.openingManager = new Opening(() => this.init2()); // アロー関数を使用
      this.openingManager.init();

      this.body.classList.add("startload");
    });

    window.addEventListener("load", () => {
      this.loadedFlg = true;

      // Resize
      this.resize = new ResizeElem();
      //this.resize.resizing();

      this.body.classList.add("loaded");
      console.log("loaded");

      //page ancher
      smoothscroll.polyfill();
      this.pageAncher = new PageAncher();
      //this.pageAncher.init();

      window.setTimeout(() => {
        //this.scrChecker.initAfterLoaded(); //FV以下のコンテンツへの対応
        this.scrChecker.onUpdate();

        // スクロール時
        window.addEventListener("scroll", () => {
          this.openingManager.onScroll();
          this.scrChecker.onUpdate();

          //clip-pathの更新だけはrequestAnimationFrameで -> onUpdate内にもどした
          //   if (!this.scrChecker.ticking) {
          //     requestAnimationFrame(this.scrChecker.updateClipPath);
          //     this.scrChecker.ticking = true;
          //   }
          //   this.scrChecker.updateClipPath();
        });

        // ウインドウリサイズ時
        window.addEventListener("resize", () => {
          this.scrChecker.onUpdate();
          if (this.timerResized !== false) {
            clearTimeout(this.timerResized);
          }
          this.timerResized = setTimeout(() => {
            this.env.detectEnv();

            this.resize.resizing();
            this.openingManager.onResize();

            //console.log('cover resizing on resize event');
            //this.openingManager.onResize();
          }, 300);
        });
      }, 300);
    });

    // ブラウザバック時
    window.addEventListener("pageshow", () => {
      this.dmenu.browserback();
      this.scrChecker.onUpdate();
    });
  }

  init2() {
    //FV以下コンテンツのload後
    //console.log(this.scrChecker);
    this.scrChecker.initAfterLoaded();
    this.pageAncher.init();
    this.resize.resizing();
    this.scrChecker.onUpdate();
    this.scrChecker.updateClipPath();
  }
}

var APP = new Main();
APP.init();
